import React, { useContext, useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContext } from '../../../navigation/AuthProvider';
import ProductController, {
  SetItemProductType,
  SetMenuItemType,
  SetMenuType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { CurrentStoreContext } from '../../../controller/StoreController';

const SetMenuIndex = () => {
  const showToast = useToast();
  const navigate = useNavigate();
  const [setMenuList, setSetMenuList] = useState<SetMenuType[]>([]);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const navigateSetMenuInfo = async (set_menu_info?: SetMenuType) => {
    if (set_menu_info) {
      // const productInfo = await getSelectedProduct(product_id!);
      navigate(`/product/setmenu/edit`, { state: { setMenuInfo: set_menu_info } });
    } else navigate(`/product/setmenu/edit`);
  };

  // API 호출
  const getSetMenuData = async () => {
    try {
      const oRes = await ProductController.getAllSetProductList(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllSetProductList', oResponse);
        if (oResponse.data) {
          setSetMenuList([...oResponse.data]);
          let openTemp = new Array(oResponse.data.length).fill(false);
          openTemp[0] = true;
          setIsOpen([...openTemp]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const changeIndexSetMenuData = async () => {
    try {
      const oRes = await ProductController.editSetProductIdOrder(currentStore.value, setMenuList);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('editSetProductIdOrder', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('세트메뉴의 순서를 변경했어요');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getSetMenuData();
  }, [currentStore]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > setMenuList.length - 1) toIndex = setMenuList.length;
    const newItems = [...setMenuList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setSetMenuList(newItems);
    setIsOpen(new Array(setMenuList.length).fill(false));
  };

  interface DraggableItemProps {
    item: SetMenuType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderSetMenu = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    // const [, drag] = useDrag({
    //   type: 'ITEM',
    //   item: { item, index },
    // });

    // const [, drop] = useDrop({
    //   accept: 'ITEM',
    //   hover: (item: { index: number }, monitor: DropTargetMonitor) => {
    //     if (item.index !== index) {
    //       moveItem(item.index, index);
    //       item.index = index;
    //     }
    //   },
    // });

    const moveMenuItem = (mainIndex: number, fromIndex: number, toIndex: number) => {
      if (toIndex < 1) toIndex = 0;
      else if (toIndex > setMenuList[mainIndex].set_prd_type_list.length - 1)
        toIndex = setMenuList[mainIndex].set_prd_type_list.length;
      let newMainItems = [...setMenuList];
      const newItems = [...newMainItems[mainIndex].set_prd_type_list];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      newMainItems[mainIndex].set_prd_type_list = newItems;
      setSetMenuList(newMainItems);
    };

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <div className="row">
              <input
                // ref={(node) => drag(drop(node))}
                value={selectedIndex}
                autoFocus={false}
                onChange={(e) => {
                  setSelectedIndex(Number(e.target.value));
                }}
                onBlur={() => {
                  moveItem(index, selectedIndex - 1);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    moveItem(index, selectedIndex - 1);
                  }
                }}
                disabled={true}
              />
            </div>
            <h3>{item.set_prd_name}</h3>
          </div>
          <div className="row gap">
            <h3>{item.set_base_price.toLocaleString()}원</h3>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateSetMenuInfo(item)}
            />
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            {item.set_prd_type_list.map((subItem: SetMenuItemType, subIndex: number) => {
              return (
                <RenderMenuItem
                  key={`${index}_${subIndex}`}
                  mainIndex={index}
                  subItem={subItem}
                  subIndex={subIndex}
                  moveMenuItem={moveMenuItem}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  };

  interface DraggableMenuItemProps {
    subItem: SetMenuItemType;
    mainIndex: number;
    subIndex: number;
    moveMenuItem: (mainIndex: number, fromIndex: number, toIndex: number) => void;
  }

  const RenderMenuItem = ({
    subItem,
    mainIndex,
    subIndex,
    moveMenuItem,
  }: DraggableMenuItemProps) => {
    const [selectedMenuIndex, setSelectedMenuIndex] = useState<number>(subIndex + 1);

    const getItemNames = () => {
      let nameTemp = '';
      subItem.product_list.map((product: SetItemProductType) => {
        nameTemp = nameTemp + product.prd_name + '/';
      });
      nameTemp = nameTemp.slice(0, -1);
      return nameTemp;
    };

    const [, menuDrag] = useDrag({
      type: 'ITEM',
      item: { mainIndex, subItem, subIndex },
    });

    const [, menuDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { mainIndex: number; subIndex: number }, monitor: DropTargetMonitor) => {
        if (item.mainIndex === mainIndex && item.subIndex !== subIndex) {
          moveMenuItem(mainIndex, item.subIndex, subIndex);
          item.subIndex = subIndex;
        }
      },
    });

    return (
      <div className="menuItem" key={subIndex}>
        <div className="row gap">
          <input
            ref={(node) => menuDrag(menuDrop(node))}
            value={selectedMenuIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedMenuIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
              }
            }}
          />
          <div className="column">
            <h4>{subItem.set_type_name}</h4>
            <h5>{getItemNames()}</h5>
          </div>
        </div>
        {subItem.input_min > 0 && <div className="maxBadge">필수선택 {subItem.input_min}개</div>}
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        {/* <input
            value={categoryName}
            placeholder="상품분류명을 입력해주세요"
            onChange={(e) => setCategoryName(e.target.value)}
          /> */}
        <button className="addButton" onClick={() => navigateSetMenuInfo()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>세트메뉴 추가하기</h4>
        </button>

        <div className="warningSign">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
          <div>
            <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
          </div>
        </div>

        <DndProvider backend={HTML5Backend}>
          <div className="setMenuList">
            {setMenuList.map((item: SetMenuType, index: number) => {
              return <RenderSetMenu key={index} item={item} index={index} moveItem={moveItem} />;
            })}
          </div>
        </DndProvider>
        <button className={`submitButton`} onClick={changeIndexSetMenuData}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default SetMenuIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input {
    width: 100%;
    padding: 10px 12px 10px 30px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .setMenuList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      input {
        width: 30px;
        height: 30px;
        padding: 4px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        text-align: center;
        color: #40977f;
        background: #ecf5f3;
        border: 1px solid #4dd2ae;
        border-radius: 4px;
      }

      .row {
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }

      .loadButton {
        display: flex;
        align-items: center;
        border: 1px solid #4dd2ae;
        border-radius: 5px;
        padding: 4px 9px;
        gap: 4px;

        h5 {
          color: #40977f;
          font-weight: 600;
        }
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      flex-direction: column;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;

      .menuItem {
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 22px;
        border-bottom: 1px solid #f7f7f7;

        input {
          width: 24px;
          height: 24px;
          padding: 4px;
          font-size: 14px;
          line-height: 16px;
          text-align: center;
          color: #979797;
          background: #ffffff;
          border: 1px solid #cecece;
        }
        .row.gap {
          width: 60%;
          gap: 20px;
        }
        .column {
          width: 100%;
          gap: 2px;
        }
        h4 {
          color: #555555;
          font-weight: 600;
        }
        h5 {
          color: #555555;
          font-weight: 400;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .maxBadge {
          border-radius: 5px;
          border: 1px solid #40977f;
          color: #40977f;
          padding: 4px 10px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
          white-space: nowrap;
        }
      }
    }
  }
`;
